<template>
	<div class="settings-wrapper blocked-users-list-wrapper">
		<BackToSettings />
		<h2 class="title header-30" v-t="'settings_option_blockedusers'" />
		<div>
			<ul class="blocked-users-list" v-if="!noResults">
				<li
					v-for="user in store.auth.user.blocked"
					:key="user.id"
					@click.stop="buildProfileCard(user)"
					:data-value="user.id"
					class="blocked-users-content"
				>
					<div class="block-user-profile">
						<ProfilePic
							:user="user"
							class="profile-pic"
							:size="profileWidth + 'px'"
						/>

						<div class="blocked-user-name">
							{{ user.fullname }}
						</div>
					</div>
					<Button
						primary
						@click.stop="unBlockUser(user)"
						:aria-label="$t('people_unblock_button_title')"
						:loading="user.loading"
					>
						{{ $t('people_unblock_button_title') }}
					</Button>
				</li>
			</ul>
		</div>
		<ProfileCard
			v-if="showProfileCard"
			@close="showProfileCard = false"
			v-bind:profileData="profileData"
			:noGroup="true"
		/>

		<div
			v-if="noResults"
			class="no-results"
			v-t="'settings_blockedusers_empty'"
		/>
	</div>
</template>

<script>
import store from '@/store'
import { post } from '@/helpers/api'
import { ProfilePic, Button } from '@/components/common'
import ProfileCard from '@/components/ProfileCard'
import BackToSettings from './BackToSettings'
import i18n from '@/i18n'

export default {
	components: {
		ProfilePic,
		ProfileCard,
		Button,
		BackToSettings,
	},
	data() {
		return {
			store,
			profileWidth: 36,
			showProfileCard: false,
			profileData: null,
		}
	},

	emits: ['error'],

	computed: {
		noResults() {
			return this.store.auth.user.blocked.length === 0
		},
	},

	methods: {
		buildProfileCard(user) {
			this.profileData = user
			this.showProfileCard = true
		},

		async unBlockUser(user) {
			user.loading = true
			try {
				const { data } = await post('/api/v1/user.unblock', {
					user_id: user.id,
				})
				this.store.auth.user.blocked = data.user.blocked
			} catch (error) {
				console.error(error)
				this.$emit('error', i18n.global.t('common_api_error_save'))
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.blocked-users-list-wrapper {
	position: relative;
	padding: 50px 50px 0 50px;
	overflow-y: auto;

	.title {
		color: var(--neutral-800);
		margin: 0 auto;
		text-align: center;
	}
}

.blocked-users-list {
	list-style: none;
	padding: 0;
	margin: 15px auto;
	overflow-y: auto;
	max-width: 800px;
}

.blocked-users-content {
	position: relative;
	@include flex-spread;
	height: 60px;
	width: 100%;
	cursor: pointer;
	padding: 8px;
	margin-bottom: 16px;
	&:hover {
		border-radius: 12px;
		background-color: var(--neutral-100);
	}
	&:last-child {
		margin-bottom: 0px;
	}
	.block-user-profile {
		display: flex;
		align-items: center;
		flex-grow: 1;
	}
}

.blocked-user-name {
	font-family: Avenir-Heavy;
	font-size: 15px;
	display: table-cell;
	vertical-align: middle;
	margin-left: 5px;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.no-results {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 75vh;
	font-size: 14px;
	font-family: Avenir-Medium;
	color: #9498a3;
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.blocked-users-list-wrapper {
		.blocked-users-content {
			&:hover {
				background-color: var(--neutral-0);
			}
		}
	}
}
</style>
